import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const NavSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 4rem;
`;

export const ButtonStyled = styled(Button)`
  font-size: 1.6rem;
  font-weight: 700;
  text-transform: uppercase;
`;
